export default "__VITE_ASSET__DElhITc8__"